(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_muse_slide"] && !Shopify.designMode) return;
  try {
    class EmailCaptureButton extends HTMLElement {
  // Static flag ensures only one modal auto-opens across all instances
  static autoOpenTriggered = false;

  constructor() {
    super();
    this.controller = new AbortController();
    this.autoOpenTimeoutId = null;
  }

  connectedCallback() {
    // Reset AbortController if it was aborted
    if (this.controller.signal.aborted) {
      this.controller = new AbortController();
    }

    const opensEmailCaptureModal = this.dataset.opensEmailCaptureModal === 'true';
    const $btn = this.querySelector('button.js-email-capture-btn');
    if (!$btn || $btn.disabled) {
      return;
    }

    // If modal is enabled, Move modal and overlay
    if (opensEmailCaptureModal) {
      const modalId = this.dataset.waitlistModalId;

      if (modalId) {
        // Move modal and overlay to body so they render correctly
        const modal = document.getElementById(modalId);
        if (modal && modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }

        // Derive overlay ID from modal ID
        const overlayId = modalId.replace('KlaviyoWaitlistModal-', 'KlaviyoWaitlistModalOverlay-');
        const overlay = document.getElementById(overlayId);
        if (overlay && overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }

        // Handle auto-open functionality
        this.maybeAutoOpenModal(modal);

        // Cancel auto-open if user manually clicks the button
        $btn.addEventListener('click', () => {
          this.cancelAutoOpen();
          // Prevent other instances from auto-opening
          EmailCaptureButton.autoOpenTriggered = true;
        }, {
          signal: this.controller.signal,
          once: true,
        });
      }
    }
  }

  /**
   * Cancels the auto-open timeout if it's pending.
   */
  cancelAutoOpen() {
    if (this.autoOpenTimeoutId) {
      clearTimeout(this.autoOpenTimeoutId);
      this.autoOpenTimeoutId = null;
    }
  }

  /**
   * Auto-opens the waitlist modal if enabled via settings.
   * Uses a static flag to ensure only one modal auto-opens across all instances.
   * @param {HTMLElement} modal - The modal element to open.
   */
  maybeAutoOpenModal(modal) {
    const shouldAutoOpen = this.dataset.autoOpen === 'true';
    if (!shouldAutoOpen || EmailCaptureButton.autoOpenTriggered) {
      return;
    }

    const delaySeconds = parseFloat(this.dataset.autoOpenDelay) || 0;
    // Minimum 100ms delay ensures modal has initialized after being moved to body
    const delayMs = Math.max(delaySeconds * 1000, 100);

    this.autoOpenTimeoutId = setTimeout(() => {
      // Check flag again in case another instance opened first
      if (EmailCaptureButton.autoOpenTriggered) {
        return;
      }

      if (modal && typeof modal.open === 'function') {
        EmailCaptureButton.autoOpenTriggered = true;
        modal.open();
      }
    }, delayMs);
  }

  disconnectedCallback() {
    this.controller.abort();
    this.cancelAutoOpen();
  }
}

function init() {
  if (customElements.get('email-capture-button')) {
    return;
  }
  customElements.define('email-capture-button', EmailCaptureButton);
}

init();
  } catch(e) { console.error(e); }
})();

})();
